(function () {
  function hoistCart() {
    var drawer = document.querySelector("cart-drawer-component");
    if (drawer && drawer.parentElement !== document.body) {
      document.body.appendChild(drawer);
    }
    return drawer;
  }

  function bindCart(root) {
    var link = root.querySelector("[data-yz-cart]");
    if (!link || link.dataset.yzBound === "1") return;
    link.dataset.yzBound = "1";
    link.addEventListener("click", function (event) {
      var drawer = hoistCart();
      if (!drawer || typeof drawer.open !== "function") return;
      event.preventDefault();
      event.stopPropagation();
      window.requestAnimationFrame(function () {
        drawer.open();
      });
    });
  }

  function imageSrc(image) {
    if (!image || !image.src) return "";
    var src = image.src;
    return src + (src.indexOf("?") === -1 ? "?" : "&") + "width=1000";
  }

  function loadCollection(handle) {
    var page = 1;
    var products = [];

    function next() {
      return fetch(
        "/collections/" + encodeURIComponent(handle) + "/products.json?limit=250&page=" + page
      )
        .then(function (response) {
          if (!response.ok) throw new Error("Could not load " + handle);
          return response.json();
        })
        .then(function (data) {
          var batch = data.products || [];
          products = products.concat(batch);
          if (batch.length < 250 && page < 8) {
            return products;
          }
          if (batch.length < 250 || page >= 8) return products;
          page += 1;
          return next();
        });
    }

    return next();
  }

  var EASE = "cubic-bezier(0.22, 1, 0.36, 1)";

  function kindOf(product, panel) {
    var type = String(product.product_type || "").toLowerCase();
    var title = String(product.title || "").toLowerCase();
    if (panel === "accessories") {
      if (/earring/.test(title)) return "earrings";
      if (/necklace|pendant|\bchain\b/.test(title)) return "necklace";
      if (/bracelet|bangle|\bcuff\b/.test(title)) return "bracelet";
      return "other";
    }
    var bare = title.replace(/[\u201c\u201d"]/g, "").replace(/\s+/g, " ").trim();
    if (
      bare === "ribs tee" ||
      bare === "gas tee" ||
      bare === "bright tee" ||
      bare === "scence tee" ||
      bare === "lord tee" ||
      /long[\s-]*sleeve|longsleeve/.test(type) ||
      /long[\s-]*sleeve|longsleeve/.test(bare)
    ) {
      return "longsleeve";
    }
    if (type === "hoodie" || /hoodie|sweatshirt|crewneck|zip[\s-]*up/.test(bare)) return "hoodie";
    if (type === "pants" || /\b(pants|trousers|jeans|denim)\b/.test(bare)) return "pants";
    return "tee";
  }

  function isJewelry(product) {
    var type = String(product.product_type || "").toLowerCase();
    var title = String(product.title || "").toLowerCase();
    if (/jewel|accessor/.test(type)) return true;
    return /\b(bracelet|earrings?|necklace|hair\s?clips?|hairclip|headband|bangle)\b/.test(title);
  }

  function flip(elements, mutate) {
    var first = new Map();
    elements.forEach(function (el) {
      if (el.hidden) return;
      first.set(el, el.getBoundingClientRect());
    });
    mutate();
    elements.forEach(function (el) {
      var from = first.get(el);
      if (!from || el.hidden) return;
      var to = el.getBoundingClientRect();
      var dx = from.left - to.left;
      var dy = from.top - to.top;
      if (Math.abs(dx) < 1 && Math.abs(dy) < 1) return;
      el.animate(
        [
          { transform: "translate(" + dx + "px," + dy + "px)" },
          { transform: "none" },
        ],
        { duration: 980, easing: EASE }
      );
    });
  }

  function colorwayParts(product) {
    var title = String((product && product.title) || "").trim();
    var match = title.match(/^(.*\S)\s+\(([A-Za-z]{3})\)$/);
    if (!match) return null;
    return {
      base: match[1].replace(/\s+/g, " ").toUpperCase(),
      code: match[2].toUpperCase(),
      fit: /-wmns$/.test(product.handle || "") ? "w" : "m",
    };
  }

  function colorKey(product) {
    var parts = colorwayParts(product);
    if (!parts) return "";
    return parts.base + "|" + parts.fit;
  }

  function familiesOf(products) {
    var map = {};
    (products || []).forEach(function (product) {
      var key = colorKey(product);
      if (!key) return;
      if (!map[key]) map[key] = [];
      map[key].push(product);
    });
    return map;
  }

  function renderGrid(grid, products, panel, options) {
    options = options || {};
    grid.replaceChildren();
    if (!products.length) {
      var empty = document.createElement("p");
      empty.className = "yz-empty";
      empty.textContent = "Coming soon";
      grid.appendChild(empty);
      return;
    }
    products.forEach(function (product, index) {
      var card = document.createElement("a");
      card.className = "yz-card";
      card.dataset.kind = kindOf(product, panel);
      card.href = "/products/" + product.handle;
      var image = (product.images || [])[0];
      if (image) {
        var img = document.createElement("img");
        img.alt = product.title || "";
        img.src = imageSrc(image);
        img.decoding = "async";
        img.loading = index < 6 ? "eager" : "lazy";
        if (image.width && image.height) {
          img.width = image.width;
          img.height = image.height;
        }
        card.appendChild(img);
      }
      var parts = colorwayParts(product);
      var name = document.createElement("span");
      name.textContent = options.inColorway && parts ? parts.code : product.title || product.handle;
      card.appendChild(name);
      if (!options.inColorway && options.onColorway) {
        card.addEventListener("click", function (event) {
          if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) return;
          var key = colorKey(product);
          var family = key && options.families && options.families[key];
          if (!family || family.length < 2) return;
          event.preventDefault();
          options.onColorway(panel, key, family);
        });
      }
      grid.appendChild(card);
    });
  }

  function showError(grid, message) {
    grid.replaceChildren();
    var empty = document.createElement("p");
    empty.className = "yz-empty";
    empty.textContent = message;
    grid.appendChild(empty);
  }

  function initCatalog(root) {
    var grids = {
      clothing: root.querySelector('[data-yz-panel="clothing"] [data-yz-grid]'),
      accessories: root.querySelector('[data-yz-panel="accessories"] [data-yz-grid]'),
    };
    var panels = {
      clothing: root.querySelector('[data-yz-panel="clothing"]'),
      accessories: root.querySelector('[data-yz-panel="accessories"]'),
    };
    var tabs = root.querySelectorAll("[data-yz-tab]");
    var zoom = root.querySelector("[data-yz-zoom]");
    var zoomIcon = root.querySelector("[data-yz-zoom-icon]");
    var mobileQuery = window.matchMedia("(max-width: 749px)");
    function colsKey() {
      return mobileQuery.matches ? "yz-cols-m" : "yz-cols-d";
    }
    var saved = "";
    try {
      saved = sessionStorage.getItem(colsKey()) || "";
    } catch (err) {}
    var cols = saved === "1" || saved === "2" || saved === "3" ? Number(saved) : mobileQuery.matches ? 2 : 3;

    var filters = { clothing: "", accessories: "" };
    var loaded = { clothing: [], accessories: [] };
    var colorway = null;
    var pushedColorway = false;

    function colorParam() {
      try {
        return new URL(window.location.href).searchParams.get("colors") || "";
      } catch (err) {
        return "";
      }
    }

    function syncChrome() {
      root.classList.toggle("is-colorways", Boolean(colorway));
      if (!zoomIcon || !zoom) return;
      if (colorway) {
        zoomIcon.textContent = "<";
        zoom.setAttribute("aria-label", "Back");
        return;
      }
      zoomIcon.textContent = cols === 1 ? "<" : "+";
      zoom.setAttribute(
        "aria-label",
        cols === 1 ? "Back to three columns" : "Show larger products"
      );
    }

    function paint(panel, products, inColorway) {
      var grid = grids[panel];
      if (!grid) return;
      renderGrid(grid, products, panel, {
        families: familiesOf(loaded[panel] || []),
        inColorway: inColorway,
        onColorway: function (which, key, family) {
          openColorways(which, key, family, true);
        },
      });
    }

    function showFull(panel) {
      paint(panel, loaded[panel] || [], false);
      if (filters[panel]) applyFilter(panel, filters[panel], false);
    }

    function openColorways(panel, key, family, push) {
      colorway = { panel: panel, key: key };
      if (panels[panel] && panels[panel].hidden) setPanel(panel);
      paint(panel, family, true);
      syncChrome();
      var url = new URL(window.location.href);
      if (url.searchParams.get("colors") === key) return;
      url.searchParams.set("colors", key);
      var next = url.pathname + url.search + url.hash;
      if (push) {
        pushedColorway = true;
        history.pushState({ yzColors: key }, "", next);
      } else {
        history.replaceState({ yzColors: key }, "", next);
      }
    }

    function closeColorways(fromPop) {
      var panel = colorway ? colorway.panel : root.dataset.start === "accessories" ? "accessories" : "clothing";
      var pushed = pushedColorway;
      colorway = null;
      pushedColorway = false;
      showFull(panel);
      syncChrome();
      if (fromPop) return;
      if (pushed) {
        history.back();
        return;
      }
      var sameSite = false;
      try {
        if (document.referrer) {
          var from = new URL(document.referrer);
          sameSite = from.origin === window.location.origin && from.pathname !== window.location.pathname;
        }
      } catch (err) {}
      if (sameSite && history.state && history.state.yzColors && window.history.length > 1) {
        history.back();
        return;
      }
      var url = new URL(window.location.href);
      if (!url.searchParams.has("colors")) return;
      url.searchParams.delete("colors");
      history.replaceState(null, "", url.pathname + url.search + url.hash);
    }

    function familyFor(key) {
      var found = null;
      ["clothing", "accessories"].forEach(function (name) {
        if (found) return;
        var family = familiesOf(loaded[name] || [])[key];
        if (family && family.length > 1) found = { panel: name, key: key, family: family };
      });
      return found;
    }

    function filterFromUrl() {
      var value = "";
      try {
        value = new URL(window.location.href).searchParams.get("filter") || "";
      } catch (err) {
        return "";
      }
      value = value.toLowerCase().replace(/[\s_-]+/g, "");
      if (value === "tee" || value === "tees" || value === "tshirt" || value === "tshirts" || value === "shortsleeve" || value === "shortsleeves") {
        return "tee";
      }
      if (value === "longsleeve" || value === "longsleeves") return "longsleeve";
      if (value === "hoodie" || value === "hoodies") return "hoodie";
      if (value === "pants") return "pants";
      return "";
    }

    function cardsIn(grid) {
      return grid ? Array.prototype.slice.call(grid.querySelectorAll(".yz-card")) : [];
    }

    function applyCols(animate) {
      var cards = cardsIn(grids.clothing).concat(cardsIn(grids.accessories));
      var run = function () {
        Object.keys(grids).forEach(function (key) {
          if (grids[key]) grids[key].setAttribute("data-cols", String(cols));
        });
      };
      if (animate) flip(cards, run);
      else run();
      syncChrome();
      try {
        sessionStorage.setItem(colsKey(), String(cols));
      } catch (err) {}
    }

    function setPanel(name) {
      Object.keys(panels).forEach(function (key) {
        var on = key === name;
        if (!panels[key]) return;
        panels[key].hidden = !on;
        panels[key].classList.toggle("is-active", on);
      });
      tabs.forEach(function (tab) {
        tab.classList.toggle("is-active", tab.getAttribute("data-yz-tab") === name);
      });
      root.querySelectorAll("[data-yz-filters]").forEach(function (row) {
        row.hidden = row.getAttribute("data-yz-filters") !== name;
      });
      var url = new URL(window.location.href);
      if (name === "accessories") url.hash = "accessories";
      else url.hash = "";
      var state = url.searchParams.has("colors")
        ? { yzColors: url.searchParams.get("colors") }
        : null;
      history.replaceState(state, "", url.pathname + url.search + url.hash);
    }

    function panelFromHash() {
      return window.location.hash.toLowerCase().indexOf("accessories") !== -1
        ? "accessories"
        : "clothing";
    }

    function applyFilter(panel, kind, animate) {
      filters[panel] = kind;
      var row = root.querySelector('[data-yz-filters="' + panel + '"]');
      if (row) {
        row.querySelectorAll("[data-yz-filter]").forEach(function (other) {
          var on = other.getAttribute("data-yz-filter") === kind;
          other.classList.toggle("is-active", on);
          other.setAttribute("aria-pressed", on ? "true" : "false");
        });
      }
      var grid = grids[panel];
      if (!grid) return;
      var cards = cardsIn(grid);
      var update = function () {
        cards.forEach(function (card) {
          card.hidden = Boolean(kind) && card.dataset.kind !== kind;
        });
        var visible = cards.some(function (card) {
          return !card.hidden;
        });
        var note = grid.querySelector("[data-yz-empty]");
        if (!visible && cards.length) {
          if (!note) {
            note = document.createElement("p");
            note.className = "yz-empty";
            note.setAttribute("data-yz-empty", "");
            note.textContent = "Coming soon";
            grid.appendChild(note);
          }
          note.hidden = false;
        } else if (note) {
          note.hidden = true;
        }
      };
      if (animate) flip(cards, update);
      else update();
    }

    applyCols();
    var startPanel = root.dataset.start === "accessories" ? "accessories" : panelFromHash();
    var preset = filterFromUrl();
    if (preset) startPanel = "clothing";
    setPanel(startPanel);
    if (preset) applyFilter("clothing", preset, false);

    if (zoom) {
      zoom.addEventListener("click", function () {
        if (colorway) {
          closeColorways(false);
          return;
        }
        cols = cols === 1 ? 3 : cols - 1;
        applyCols(true);
      });
    }

    root.querySelectorAll("[data-yz-filter]").forEach(function (button) {
      button.addEventListener("click", function () {
        if (colorway) return;
        var row = button.closest("[data-yz-filters]");
        var panel = row ? row.getAttribute("data-yz-filters") : "clothing";
        var kind = button.getAttribute("data-yz-filter");
        var next = filters[panel] === kind ? "" : kind;
        applyFilter(panel, next, true);
      });
    });

    tabs.forEach(function (tab) {
      tab.addEventListener("click", function () {
        var name = tab.getAttribute("data-yz-tab");
        if (colorway) closeColorways(true);
        var url = new URL(window.location.href);
        if (url.searchParams.has("colors")) {
          url.searchParams.delete("colors");
          history.replaceState(null, "", url.pathname + url.search + url.hash);
        }
        setPanel(name);
        if (grids[name] && !grids[name].querySelector(".yz-card, .yz-empty")) showFull(name);
      });
    });

    window.addEventListener("hashchange", function () {
      if (colorway) closeColorways(true);
      setPanel(panelFromHash());
    });

    window.addEventListener("popstate", function () {
      var key = colorParam();
      var found = key ? familyFor(key) : null;
      if (found) {
        openColorways(found.panel, found.key, found.family, false);
        return;
      }
      if (colorway) closeColorways(true);
      setPanel(panelFromHash());
    });

    var clothingHandle = root.dataset.clothing;
    var accessoriesHandle = root.dataset.accessories;
    Promise.all([
      clothingHandle ? loadCollection(clothingHandle) : Promise.resolve([]),
      accessoriesHandle ? loadCollection(accessoriesHandle) : Promise.resolve([]),
    ])
      .then(function (lists) {
        var accessoryHandles = {};
        lists[1].forEach(function (product) {
          accessoryHandles[product.handle] = true;
        });
        loaded.clothing = lists[0].filter(function (product) {
          return !accessoryHandles[product.handle] && !isJewelry(product);
        });
        loaded.accessories = lists[1];
        var found = familyFor(colorParam());
        if (found) {
          openColorways(found.panel, found.key, found.family, false);
          return;
        }
        if (grids.clothing) showFull("clothing");
        if (grids.accessories) showFull("accessories");
      })
      .catch(function () {
        if (grids.clothing) showError(grids.clothing, "Could not load products.");
        if (grids.accessories) showError(grids.accessories, "Could not load products.");
      });
  }

  function boot() {
    hoistCart();
    document.querySelectorAll("[data-yz]").forEach(function (root) {
      bindCart(root);
      if (root.getAttribute("data-yz") === "catalog") initCatalog(root);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
